import { z } from 'zod';

export const UserSchema = z.object({
  status: z.boolean({ required_error: 'error_field_required' }),
  access: z.boolean({ required_error: 'error_field_required' }),
  role: z.coerce.number({ required_error: 'error_field_required' }).optional(),
  firstName: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  lastName: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  email: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
});

export const UserRoleSchema = z.object({
  role: z.number({ required_error: 'error_field_required' }),
});

export const UserWithoutRoleSchema = UserSchema.omit({ role: true });

export type FormUserSchemaType = z.infer<typeof UserSchema>;

export interface UserSchemaType extends FormUserSchemaType {
  id?: number;
}

export type UserWithoutRoleSchemaType = Omit<UserSchemaType, 'role'>;

export type FormUserRoleSchemaType = z.infer<typeof UserRoleSchema>;

export interface UserRoleSchemaType extends FormUserRoleSchemaType {
  id?: number;
}

export const UserProfileSchema = z.object({
  firstName: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  lastName: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  email: z.string().min(1, { message: 'error_field_required' }).max(255, {
    message: `error.field_max_lengh_255`,
  }),
  password: z.string(),
});

export type FormUserProfileSchemaType = z.infer<typeof UserProfileSchema>;

export interface UserProfileSchemaType extends FormUserProfileSchemaType {
  id?: number;
}
